/* SAHA theme — light JS: scroll fade-in only.
   Keep this minimal; Shopify handles cart/product JS via its own libs. */
(function () {
  function reveal(el) {
    el.classList.add('is-visible');
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  function initFades() {
    var els = document.querySelectorAll('[data-fade]:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }

    // threshold: 0 — any visible pixel counts.
    // Tall grids (e.g. collection product lists on mobile) can be thousands
    // of px tall; a 12% threshold never fires and leaves opacity:0 forever.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 40px 0px' });

    els.forEach(function (el) {
      if (isInViewport(el)) {
        reveal(el);
        return;
      }
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') initFades();
  else document.addEventListener('DOMContentLoaded', initFades);

  // Re-init when the theme editor injects/updates a section.
  document.addEventListener('shopify:section:load', initFades);
})();
